import React, { useRef, useState } from "react";
import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Modal from "components/common/Modal";
import { Backdrop, Fade, Typography } from "@mui/material";
import Button from "components/common/Button";
import BackupIcon from "@mui/icons-material/Backup";
import { Formik } from "formik";
import Stack from "components/common/Stack";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  modal_open: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: "20px",
  },
  heading: {
    color: "#707070",
    fontSize: "22px",
    margin: "20px",
  },
  close_button: {
    padding: "5px 45px",
    fontSize: "14px",
    marginRight: "10px",
  },
  upload_button: {
    padding: "5px 45px",
    fontSize: "14px",
  },
}));

const ChargingStationExcelUpload = ({ open, handleClose, handleExcelSubmit }) => {
  const [filename, setFileName] = useState("");
  const [file, setFile] = useState("");
  const classes = useStyles();
  const fileInputRef = useRef(null);
  const initialValues = {
    file: null,
  };

  const handleSubmit = () => {
    handleExcelSubmit(file);
    setFileName();
    setFile();
    handleClose();
  };

  const handleCloseHandler = () => {
    setFileName();
    setFile();
    handleClose();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
      >
        <Fade in={open}>
          <div className={classes.modal_open}>
            <Formik
              initialValues={initialValues}
              onSubmit={(values) => {
                let formData = new FormData();
                formData.append("file", values.file);
                values.file = "";
                handleExcelSubmit(values.file);
              }}
            >
              {({ touched, errors, setFieldValue }) => (
                <>
                  <Typography className={classes.heading}>
                    Upload File
                  </Typography>
                  <Box className={classes.center}>
                    <Card>
                      <CardContent>
                        <Box>
                          <Stack xs={6}>
                            <Box
                              className={classes.form_container}
                              sx={{ marginTop: "-10px" }}
                            >
                              <input
                                id="file"
                                name="file"
                                type="file"
                                className="form-control"
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                style={{ display: "none" }}
                                ref={fileInputRef}
                                onChange={(event) => {
                                  const file = event.currentTarget.files[0];
                                  setFieldValue("file", file);
                                  setFile(file);
                                  setFileName(file.name);
                                }}
                                error={!touched.file && Boolean(errors.file)}
                              />
                              <label
                                htmlFor="file"
                                style={{ cursor: "pointer" }}
                              >
                                <BackupIcon fontSize="large" color="primary" />
                              </label>
                              {filename && (
                                <Typography
                                  sx={{
                                    color: "#707070",
                                    margin: "10px 0",
                                  }}
                                >
                                  {filename}
                                </Typography>
                              )}
                              {errors.file && (
                                <Typography
                                  sx={{
                                    color: "red",
                                    margin: "15px -10px",
                                  }}
                                >
                                  {errors.file}
                                </Typography>
                              )}
                            </Box>
                          </Stack>
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                </>
              )}
            </Formik>
            <div style={{ display: "flex", margin: "20px" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCloseHandler}
                  className={classes.close_button}
                >
                  CANCEL
                </Button>
          
                <Button
                  className={classes.upload_button}
                  variant="contained"
                  color="primary"
                  onClick={() => handleSubmit(file)}
                >
                  UPLOAD
                </Button>
             
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ChargingStationExcelUpload;
